import { render, staticRenderFns } from "./PriorityQueue.vue?vue&type=template&id=06a1c56d&scoped=true&"
import script from "./PriorityQueue.vue?vue&type=script&lang=js&"
export * from "./PriorityQueue.vue?vue&type=script&lang=js&"
import style0 from "./PriorityQueue.vue?vue&type=style&index=0&id=06a1c56d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1c56d",
  null
  
)

export default component.exports